export const ONBOARDING_CACHE_RESET_VERSION = '2026-06-17-v5';
export const ONBOARDING_CACHE_RESET_KEY_PREFIX = 'sentry-onboarding-cache-reset-';
export const ONBOARDING_CACHE_RESET_KEY = `${ONBOARDING_CACHE_RESET_KEY_PREFIX}${ONBOARDING_CACHE_RESET_VERSION}`;
export const ONBOARDING_CACHE_RESET_PARAM = 'onboardingCacheReset';

export function hasCurrentOnboardingCacheResetMarker(
  storage: Pick<Storage, 'getItem'> | null | undefined,
  url: URL,
): boolean {
  if (url.searchParams.get(ONBOARDING_CACHE_RESET_PARAM) === ONBOARDING_CACHE_RESET_VERSION) {
    return true;
  }

  try {
    return storage?.getItem(ONBOARDING_CACHE_RESET_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeCurrentOnboardingCacheResetMarker(
  storage: Pick<Storage, 'setItem'> | null | undefined,
): void {
  try {
    storage?.setItem(ONBOARDING_CACHE_RESET_KEY, '1');
  } catch {
    // The URL marker still prevents a reload loop when localStorage is blocked.
  }
}
